import React from "react";
import { Alert } from "./Alert";
import { useAlert } from "./hooks";

const WorkplaceAlert = ({ pgName, workplaceId }) => {

  const [alert] = useAlert(`alert/${pgName}/w/${workplaceId}/`);

  return <React.Fragment>{alert && <Alert alert={alert} />}</React.Fragment>;
};

export { WorkplaceAlert };
